/**
 * Visual tokens of Tacada Limpa (assets/STYLE.md, Hitz Art Style Guide v1 style A · tactile tabletop): the one place for colors,
 * type and shape, shared by every engine (no engine imports). Views never hardcode a color.
 */
export const THEME = {
  colors: {
    bg: '#F3EFE6',        // warm paper background
    bgDeep: '#E4DDCF',    // behind the table, vignette
    panel: '#FFFFFF',     // cards, HUD plates
    panelLight: '#FAF7F1',
    felt: '#5E8A63',      // playing surface (muted green)
    feltDark: '#4C7351',
    wood: '#9C6B43',      // walls
    woodDark: '#7A5233',
    stone: '#B8B0A3',     // gates, borders
    sand: '#D9C59A',
    ramp: '#6F9A72',
    cup: '#22261F',
    ball: '#FFFFFF',
    text: '#22261F',
    textDim: '#5E6458',
    accent: '#E4572E',    // the one color that means "act here" (buttons, aim arrow, flag)
    accentDark: '#FFFFFF',// text on accent
    positive: '#2E7D5B',
    negative: '#B5432F',
    neutral: '#6C7380'
  },
  /** System stack: no font download, no license. */
  font: { family: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif', weight: 'bold' },
  /** Font sizes on the 720-wide stage (px): about 2x the CSS size on a phone. Nothing below `label`. */
  type: { title: 72, heading: 48, body: 32, label: 24 },
  shape: { radius: 24, touch: 110, border: 6, gap: 24 }
} as const

export type ThemeColor = keyof typeof THEME.colors
/** '#rrggbb' + alpha 0..1 → 'rgba(r,g,b,a)': for canvas textures so they stay on the palette. */
export const rgba = (c: ThemeColor, alpha: number) => {
  const n = hex(c)
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`
}

/** '#rrggbb' → 0xrrggbb, for engines that take numbers (Phaser fills, Three.js colors). */
export const hex = (c: ThemeColor) => parseInt(THEME.colors[c].slice(1), 16)
